import { ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import React from 'react';

import {
  CmAccordionButton,
  CmAccordionItem,
  CmFlex,
} from '@/components/uiParts';

import { TextIcon } from './TextIcon';

type CategoryType =
  | '注文データ'
  // 『メニュー管理』は他のコンポーネントで直接定義
  | 'Camel Order設定'
  | 'Camel Kiosk設定'
  | '店舗管理'
  | '配達設定'
  | '外部連携設定'
  | '設定'
  | '売上レポート(β)';

interface Props {
  category: CategoryType;
  icon: React.ReactNode;
  panel: React.ReactNode;
  isDisabled?: boolean;
}

export const CustomAccordionItem: React.VFC<Props> = ({
  icon,
  category,
  panel,
  isDisabled,
}) => {
  return (
    <CmAccordionItem border="none" isDisabled={isDisabled}>
      {({ isExpanded }) => (
        <>
          <h2>
            <CmAccordionButton>
              <CmFlex
                w="100%"
                justifyContent="space-between"
                alignItems="center"
              >
                <TextIcon icon={icon} color="white">
                  {category}
                </TextIcon>
                {isExpanded ? (
                  <ChevronDownIcon color="white" fontSize="28px" />
                ) : (
                  <ChevronLeftIcon color="white" fontSize="28px" />
                )}
              </CmFlex>
            </CmAccordionButton>
          </h2>
          {panel}
        </>
      )}
    </CmAccordionItem>
  );
};
